import DeleteIcon from '@mui/icons-material/Delete';
import InfoIcon from '@mui/icons-material/Info';
import ModeEditOutlineIcon from '@mui/icons-material/ModeEditOutline';
import { GridActionsCellItem } from '@mui/x-data-grid';
import ColImage from 'components/shared/Table/ColImage';

import TableActionButtons from '../../components/shared/TableActionButtons/TableActionButtons';

const useCarSeriesTableColumns = (
  goToInfoPage,
  deleteItem,
  editItem,
  apiRef,
  columnPermissions = {},
) => {
  const {
    canDetail = false,
    canEdit = false,
    canDelete = false,
  } = columnPermissions;

  const canViewActions = canDetail || canEdit || canDelete;

  const columnsData = [
    {
      field: 'image',
      headerName: 'تصویر',
      flex: 0.3,
      minWidth: 120,
      resizable: true,
      editable: false,
      renderCell: params => {
        apiRef.current = params.api;
        return <ColImage src={params.row.imageURL} alt={params.row.title} />;
      },
    },

    {
      field: 'title',
      headerName: 'عنوان',
      flex: 1,
      minWidth: 120,
      resizable: true,
      editable: false,
    },

    ...(canViewActions
      ? [
          {
            field: 'actions',
            headerName: 'عملیات',
            type: 'actions',
            flex: 0.5,
            align: 'right',
            minWidth: 300,

            getActions: params => {
              const buttons = [
                canEdit
                  ? {
                      label: 'ویرایش',
                      Icon: ModeEditOutlineIcon,
                      onClick: editItem(params.row),
                      color: 'info',
                    }
                  : null,
                canDetail
                  ? {
                      label: 'سال ساخت ها',
                      Icon: InfoIcon,
                      onClick: goToInfoPage(params.row),
                      color: 'success',
                    }
                  : null,
              ].filter(Boolean);

              return [
                buttons.length ? (
                  <TableActionButtons key={10} buttons={buttons} />
                ) : null,
                canDelete ? (
                  <GridActionsCellItem
                    key={2}
                    icon={<DeleteIcon />}
                    label="حذف"
                    onClick={deleteItem(params.row)}
                    showInMenu
                  />
                ) : null,
              ].filter(Boolean);
            },
          },
        ]
      : []),
  ];

  return [columnsData];
};

export default useCarSeriesTableColumns;
